// extracted by mini-css-extract-plugin
export default {"header":"PersonalisedMenteeEmailersAddLearnerModal_header__njVEN","action":"PersonalisedMenteeEmailersAddLearnerModal_action__I-6TS"};